import { JwtGameEngineSupport } from "@hub/models/challenges/engine-support";
import { RabbitModel } from "@hub/services/store/rabbit-store";

export enum MatrixState {
  IDLE = "idle",
  LOADING = "loading",
  RELOADING = "reloading",
  READY = "READY",
}

export enum MatrixQuestStatus {
  INCOMPLETE = "incomplete",
  COMPLETE = "complete",
}

export enum MatrixQuestName {
  CHASING_RABBITS = "Chasing Rabbits",
  DOWN_THE_RABBIT_HOLE = "Down the Rabbit Hole",
  YOUR_EVIDENCE = "Your Evidence",
}

export type MatrixQuest = {
  name: MatrixQuestName;
  status: MatrixQuestStatus;
};

export type MatrixQuests = {
  [index: string]: MatrixQuest;
};

export enum FollowJwtRabbitStatus {
  UNKNOWN = "unknown",
  NOT_BUILT = "not-built",
  NOT_STARTED = "not-started",
  WIP = "in-progress",
  COMPLETE = "complete",
  BLOCKED = "blocked",
}

export type FollowJwtRabbitData = {
  status: FollowJwtRabbitStatus;
  devCenterBurrow: string[];
  sessionsBurrow: string[];
};

export type MatrixServiceState = {
  state: MatrixState;
  siteRabbits: RabbitModel[];
  eventRabbits: RabbitModel[];
  quests: MatrixQuests;
  activeQuestTab: MatrixQuest;
  gameStatus: FollowJwtRabbitStatus;
  engineSupport: JwtGameEngineSupport;
  jwt: string;
};
